import { useSelector } from 'react-redux';
import styled from 'styled-components';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import { Alert } from 'foundations-components/transitional/components/Alert';
import useAudienceAccessType from '../hooks/useAudienceAccessType';
import { getContentModelPublicAccessRules } from 'page-editor-ui/redux/selectors/pageContentModelSelectors';
import AudienceAccessTypes from 'ContentUtils/constants/AudienceAccessTypes';
import { getAccessIdsLength } from 'ui-memberships-settings-lib/utils/publicAccessRuleTypes';
import { jsx as _jsx } from "react/jsx-runtime";
const AudienceAcccessAlertTitle = styled.span.withConfig({
  displayName: "PatagoniaPageAudienceAccessMsg__AudienceAcccessAlertTitle",
  componentId: "sc-1sy529u-0"
})(["text-transform:uppercase;"]);
const PatagoniaPageAudienceAccessMsg = () => {
  const audienceAccessType = useAudienceAccessType();
  const publicAccessRules = useSelector(getContentModelPublicAccessRules);
  const accessListCount = getAccessIdsLength(publicAccessRules);
  if (audienceAccessType === AudienceAccessTypes.ALL) {
    return null;
  }
  return /*#__PURE__*/_jsx(Alert, {
    type: "info",
    titleText: /*#__PURE__*/_jsx(AudienceAcccessAlertTitle, {
      children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
        message: "publishConfirmModal.audienceAccess.title"
      })
    }),
    marginBlockStart: "400",
    children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
      message: `publishConfirmModal.audienceAccess.${audienceAccessType}`,
      options: {
        count: accessListCount
      }
    })
  });
};
export default PatagoniaPageAudienceAccessMsg;